import { useEffect, useState } from "react";
import { Utility } from "../../../../model/bill-settings/bill-settings";
import BillPageLayout from "../component/layout/BillPageLayout";
import styles from "../bills.module.scss";
import utilCardStyles from "../../../../common/components/xepp/utility-card/UtilityCard.module.scss";
import UtilityCard from "../../../../common/components/xepp/utility-card/UtilityCard";
import { PostpaidHistory } from "./PostpaidHistory";
import { useConfigLayout } from "../../../../hooks/useConfigLayout";
import { useLazyGetUtilitiesQuery } from "../../../../service/utility-service";
import EmptyState from "../../../../common/components/xepp/empty-state/EmptyState";
import { UtilityIcon } from "../../../../assets/icons";
import { SkeletonGrid } from "../../../../common/components/xepp/skeleton-loader/SkeletonLoader";


export const PostpaidPage = () => {
	const [ getUtilities, { data, isLoading, error} ] = useLazyGetUtilitiesQuery();
	const { updateLayout, selectedCountry } = useConfigLayout({
		showCountrySelector: true,
		utility: null,
		showExportButton: false,
		showBreadCrumb: true,
		exportHandler: () => {},
	});
	const [selectedUtility, setSelectedUtility] = useState<Utility | undefined>();


	useEffect(()=>{
       if(selectedCountry?.isoCode) {
		 getUtilities(selectedCountry?.isoCode);
	   }
	}, [selectedCountry])


	function handleManageUtility(utility: Utility) {
		setSelectedUtility(utility);
		updateLayout({ showExportButton: true, showCountrySelector: false, utility: utility });
	}

	useEffect(() => {
		return () => {
			updateLayout({ showExportButton: false });
		};
	}, []);

	useEffect(() => {
		if (selectedUtility) {
			updateLayout({ goBackHandler: () => setSelectedUtility(undefined) });
		} else updateLayout({ goBackHandler: null, utility: null, showExportButton: false, showCountrySelector: true });
	}, [selectedUtility]);

	return (
		<BillPageLayout title={selectedUtility ? "Postpaid History" : ""}>
			{selectedUtility ? (
				<PostpaidHistory selectedUtility={selectedUtility} />
			) : (
				<div className={styles.container}>
					{isLoading && <SkeletonGrid /> }
					<div className={utilCardStyles.utilityGrid}>
					{(data && data.length === 0) ? <EmptyState icon={<UtilityIcon />} title='No utilities available' /> 
					 :  data?.map(utility => (
							   	<div key={utility.utilityCode} className={utilCardStyles.utilityCardWrapper}>
									<UtilityCard logo={utility.imageUrl} name={utility.name} description={utility?.description ?? ""} onManage={() => handleManageUtility(utility)} />
								</div>
							))
						}
					</div>
				</div>
			)}
		</BillPageLayout>
	);
};
